import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { EMPTY } from 'rxjs/internal/observable/empty';
import { of } from 'rxjs/observable/of';

import { catchError } from 'rxjs/operators';
import { mergeMap } from 'rxjs/operators/mergeMap';

import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';

@Injectable()
export class CalendarResolver implements Resolve<Object> {

    constructor(
        private loadingSvc: LoadingService,

    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        this.loadingSvc.setErrorState(null);
        this.loadingSvc.setLoadingState(false);

        // TODO: Add proper service call once it's available
        return of({})
            .pipe(
                catchError((error) => {
                    this.loadingSvc.setErrorState(error);
                    this.loadingSvc.setLoadingState(true);
                    return EMPTY;
                }),
                mergeMap((result: any) => {
                    this.loadingSvc.setLoadingState(true);
                    return of(result);
                })
            );
    }
}
